import React from 'react';
import Modal from '../Modal/Modal';
import { DialogTitle } from '@headlessui/react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { CloseButton } from 'components/buttons';

export default function DeleteModal({ isOpen, onClose, title, message, onConfirm, confirmText = "Delete", cancelText = "Cancel", loading = false }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="relative bg-gray-800 px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
        <CloseButton onClick={onClose} className="absolute right-4 top-4" />
        <div className="sm:flex sm:items-start">
          <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-500/10 sm:mx-0 sm:size-10">
            <ExclamationTriangleIcon className="size-6 text-red-400" aria-hidden="true" />
          </div>
          <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
            <DialogTitle as="h3" className="text-base font-semibold leading-6 text-white">
              {title}
            </DialogTitle>
            <div className="mt-2">
              <p className="text-sm text-gray-400">
                {message}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-gray-700/25 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
        <button
          type="button"
          className="inline-flex w-full justify-center rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-400 sm:ml-3 sm:w-auto disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? 'Processing...' : confirmText}
        </button>
        <button
          type="button"
          className="mt-3 inline-flex w-full justify-center rounded-md bg-white/10 px-3 py-2 text-sm font-semibold text-white inset-ring inset-ring-white/5 hover:bg-white/20 sm:mt-0 sm:w-auto cursor-pointer"
          onClick={onClose}
          disabled={loading}
        >
          {cancelText}
        </button>
      </div>
    </Modal>
  );
}
